module.exports = __webpack_public_path__ + "img/login_logo.1e0bc907.png";